var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSchoolGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.4999 50.8775L64.8306 26.1406L45.1614 50.8775H22.2139V102H50.0787V73.9652H79.5826V102H107.447V50.8775H84.4999Z",
    fill: "#7BCCB7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9131 14.5967V21.1932",
    stroke: "#7BCCB7",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.53 45.9297V97.0525H17.2964V45.9297",
    stroke: "#161616",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1606 97.0527V69.0176H74.6646V97.0527",
    stroke: "#161616",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9957 27.7899H20.2958L14.0181 45.9302H40.2438L59.913 21.1934L79.5823 45.9302H105.808L99.5303 27.7899H64.8304",
    stroke: "#161616",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9134 50.8766C63.5344 50.8766 66.4698 47.9232 66.4698 44.2801C66.4698 40.6369 63.5344 37.6836 59.9134 37.6836C56.2923 37.6836 53.3569 40.6369 53.3569 44.2801C53.3569 47.9232 56.2923 50.8766 59.9134 50.8766Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9131 69.0176V97.0527",
    stroke: "#161616",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3868 8H58.2739V14.5965H71.3868V8Z",
    fill: "#7BCCB7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1309 59.124V85.51",
    stroke: "#161616",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDasharray: "3 3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9653 59.124V85.51",
    stroke: "#161616",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDasharray: "3 3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8608 59.124V85.51",
    stroke: "#161616",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDasharray: "3 3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6948 59.124V85.51",
    stroke: "#161616",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDasharray: "3 3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSchoolGreen);
export default __webpack_public_path__ + "static/media/icon-school-green.553660b8673d04dffa583f1f91297123.svg";
export { ForwardRef as ReactComponent };